import { cn } from 'components/UI/cn'

/**
 * Small circular initials avatar used in "Created By" / owner / author table
 * cells. Carries `data-initials-avatar` so main.css can flip its fill to white
 * on row hover/selected (keeps the initials legible against the row's hover
 * background). Replaces the gray-circle markup that was copy-pasted inline
 * across ~11 table column definitions.
 */
export function InitialsAvatar({
  initials,
  className,
}: {
  initials: string
  className?: string
}) {
  return (
    <div
      data-initials-avatar
      className={cn(
        'flex shrink-0 items-center justify-center rounded-full text-xs font-medium leading-4',
        className
      )}
      style={{
        width: 24,
        height: 24,
        backgroundColor: '#F3F4F6',
        color: '#374151',
        letterSpacing: '-0.2px',
      }}
    >
      {initials}
    </div>
  )
}
